import { Route, Routes } from "react-router-dom";
import Login from "../src/pages/login/Login";
import ProspectiveDashboard from "./pages/ProspectiveDashboard";
import Dashboard from "./pages/Dashboard";
import ViewDetails from "./pages/viewDetails";
import AdminAccept from "./pages/acceptreject";
import VacancySettings from "./pages/vacancySettings";
import AdminSettings from "./pages/adminSettings";
import AcceptMail from "./pages/acceptmail";
import AllVerificationsPage from "./pages/allverificationspage";
import NotFound from "./pages/NotFound";
import MonthlyAssesmentTable from "./components/applications/table/MonthlyAssesmentTable";
import MonthlyAssessmentForm from "./components/Forms/MonthlyAssesmentForm";
import ManageVacancy from "./pages/managevacancy";
import RequireAuth from "./pages/RequireAuth";
import AllApplicationsPage from "./pages/allapplicationspage";
import AllAcceptPage from "./pages/allacceptpage";
import ApprovalPortalHelp from "./pages/help";
import Accepted from "./pages/accepted";
import ManageCourses from "./pages/managecourses";
import FinalAssesmentForm from "./components/Forms/FinalAssesmentForm";
import Error from "./pages/error";
import GenerateReport from "./components/Forms/generateReport";
import AssignSupervisor from "./components/Forms/assignSupervisor";
import { FlashMessageProvider } from "./contexts/FlashMessageContext";
import PaymentAdvicePage from "./pages/paymentAdvicePage";
import MainLayout from "./layouts/MainLayout";
import FinalSiwesApplications from "./pages/acceptsiwes";
import SecurityPage from "./pages/Security";
import DeploymentsPage from "./pages/Deployments";
import EndorsementsPage from "./pages/Endorsements";
import SupervisionPage from "./pages/Supervision";
import ComplianceSettings from "./pages/complianceSettings";
import BuildingSettings from "./pages/buildingSettings";

function App() {
  return (
    <FlashMessageProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/error" element={<Error />} />
        <Route path="*" element={<NotFound />} />
        <Route element={<MainLayout />}>
          <Route path="/help" element={<ApprovalPortalHelp />} />

          <Route element={<RequireAuth permission={["view"]} />}>
            <Route
              path="/view/:internship_type/:application_id"
              element={<ViewDetails />}
            />
          </Route>

          <Route element={<RequireAuth permission={["verify"]} />}>
            <Route
              path="/approval/:internship_type/:application_id"
              element={<ProspectiveDashboard />}
            />
            <Route path="/allapp" element={<AllApplicationsPage />} />
          </Route>

          <Route element={<RequireAuth permission={["approve"]} />}>
            <Route
              path="/adminaccept/:internship_type/:application_id"
              element={<AdminAccept />}
            />
            <Route path="/adapplications" element={<AllVerificationsPage />} />
          </Route>

          <Route element={<RequireAuth />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
              path="report/final-assesments"
              element={<MonthlyAssesmentTable />}
            />
          </Route>

          <Route element={<RequireAuth permission={["accept"]} />}>
            <Route path="/accapplications" element={<AllAcceptPage />} />
            <Route path="/accepted" element={<Accepted />} />
            <Route
              path="/accsiwesapplications"
              element={<FinalSiwesApplications />}
            />
            <Route
              path="/acceptmail/:internship_type/:application_id"
              element={<AcceptMail />}
            />
          </Route>

          <Route element={<RequireAuth permission={["admin"]} />}>
            <Route path="/managevacancy" element={<ManageVacancy />} />
            <Route path="/vacancysettings" element={<VacancySettings />} />
            <Route path="/adminsettings" element={<AdminSettings />} />
            <Route path="/managecourses" element={<ManageCourses />} />
            <Route path="/compliance" element={<ComplianceSettings />} />
            <Route path="/editbuildings" element={<BuildingSettings />} />
          </Route>

          {/* NEW: Operational Routes */}

          {/* Security */}
          <Route element={<RequireAuth permission={["security_view"]} />}>
            <Route path="/security" element={<SecurityPage />} />
          </Route>

          {/* Deployments (Assign Supervisor) */}
          <Route element={<RequireAuth permission={["assign_supervisor"]} />}>
            <Route path="/deployments" element={<DeploymentsPage />} />
            <Route
              path="/report/payment-advice"
              element={<PaymentAdvicePage />}
            />
            <Route path="/generatereport/:id" element={<GenerateReport />} />
            <Route
              path="/assignsupervisor/:id"
              element={<AssignSupervisor />}
            />
          </Route>

          {/* Endorsements (Manage) */}
          <Route element={<RequireAuth permission={["manage"]} />}>
            <Route path="/endorsements" element={<EndorsementsPage />} />
          </Route>

          {/* My Interns (Supervise) */}
          <Route element={<RequireAuth permission={["supervise", "all"]} />}>
            <Route path="/supervision" element={<SupervisionPage />} />
            <Route
              path="/monthlyassesment/:id"
              element={<MonthlyAssessmentForm />}
            />
            <Route path="/finalassesment" element={<FinalAssesmentForm />} />
          </Route>
        </Route>
      </Routes>
    </FlashMessageProvider>
  );
}

export default App;
